import React, { Component } from 'react'
//style
import './style.css'

class BalanceTiers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noOfTier: 1,
      tierSection: [{
        balanceForEnhancementMargin: '',
        from: '',
        to: '',
        balanceEligibleAccountsForPremiumMargin: '',
      }],
      payload: []
    }
  }

  componentWillReceiveProps = (nextProps) => {

    if (nextProps.data.length > 0) {
      this.setState({
        noOfTier: nextProps.data.length,
        tierSection: nextProps.data
      });
    } else {
      this.setState(prevState => ({
        noOfTier: prevState.noOfTier
      }))
    }

    if (nextProps.data.length === 5) {
      this.setState({
        disabledBtn: true
      })
    }
  }

  componentDidMount() {
    if (this.props.data.length > 0) {
      this.setState({
        noOfTier: this.props.data.length,
        tierSection: this.props.data
      });
    } else {
      this.setState(prevState => ({
        noOfTier: prevState.noOfTier
      }))
    }
  }

  addTire = () => {
    var addTier = {
      balanceForEnhancementMargin: '',
      from: '',
      to: '',
      balanceEligibleAccountsForPremiumMargin: '',
    }
    var _stateTierSection = this.state.tierSection;
    if (this.state.noOfTier < 5) {
      _stateTierSection.push(addTier);
      this.setState(prevState => ({
        noOfTier: prevState.noOfTier === 5 ? 5 : prevState.noOfTier + 1,
        data: _stateTierSection
      }))
    } if (this.state.noOfTier === 4) {
      this.setState({
        disabledBtn: true
      })
    }

  }

  tireDeletion = (index) => {

    let deleteTier = [...this.state.tierSection]
    deleteTier.splice(index, 1)

    this.setState(prevState => ({
      noOfTier: prevState.noOfTier - 1,
      tierSection: deleteTier,
      disabledBtn: false
    }))
    this.props._tireData(deleteTier);
    this.props._deletedTierIndex(index);
  }

  handleInputChange = (event) => {
    let stateObj = this.state.tierSection
    let eventName = event.target.name;
    let eventNamesArr = eventName.split("_");
    let actualName = eventNamesArr[0];
    let indexNo = eventNamesArr[1];
    switch (actualName) {
      case 'balanceForEnhancementMarginFrom':
        stateObj[indexNo].from = event.target.value;
        break;
      case 'balanceForEnhancementMarginTo':
        stateObj[indexNo].to = event.target.value;
        break;
      case 'balanceForEnhancementMargin':
        stateObj[indexNo].balanceForEnhancementMargin = event.target.value;
        break;
      case 'balanceEligibleAccountsForPremiumMargin':
        stateObj[indexNo].balanceEligibleAccountsForPremiumMargin = event.target.value;
        break;
      default:
        return actualName;
    }

    this.setState({
      tierSection: stateObj
    });
    this.props._tireData(stateObj);
  }

  render() {
    var tierSectionJSX = []
    for (var i = 0; i < this.state.noOfTier; i++) {
      tierSectionJSX.push(
        <div className="tire-setting--row--wrapper" key={i}>

          {i > 0 ? <span className="delete-btn" role="button" onClick={this.props.disabled ? undefined : this.tireDeletion.bind(this, i)}><i className="icon icon-bin"></i></span> : ''}
          <div className="row wrapper-row-field">
            <div className="tier-row">
              <label>{this.props.sectionLabel} {i + 1}</label>
              <div className="combo-box">
                <p className="combo-box__label">{this.props.subLabels[0]}</p>
                <input
                  type="text"
                  className="combo-box__input"
                  value={this.state.tierSection[i].from}
                  name={`balanceForEnhancementMarginFrom_${i}`}
                  disabled={this.props.disabled}
                  onChange={this.handleInputChange}
                  maxLength={this.props.maxChars[0]}
                />
              </div>
              <div className="combo-box">
                <p className="combo-box__label">{this.props.subLabels[1]}</p>
                <input
                  type="text"
                  className="combo-box__input"
                  value={this.state.tierSection[i].to}
                  name={`balanceForEnhancementMarginTo_${i}`}
                  disabled={this.props.disabled}
                  onChange={this.handleInputChange}
                  maxLength={this.props.maxChars[0]}
                />
              </div>
            </div>
          </div>
          {/* {
            this.props.premiumVal &&
            <div className="wrapper-row-field">
              <label>{this.props.subLabels[1]}</label>
              <input
                type="text"
                value={this.state.tierSection[i].balanceEligibleAccountsForPremiumMargin}
                name={`balanceEligibleAccountsForPremiumMargin_${i}`}
                disabled={this.props.disabled}
                onChange={this.handleInputChange}
                maxLength={this.props.maxChars[0]}
              />
            </div>
          } */}

        </div>
      )
    }

    return (
      <div className="tire-setting">
        <div className="tire-setting--row">
          <h4 className="title">{this.props.boxLabel}</h4>
          {tierSectionJSX}
          <div className="gdocs-mtop-30 gdocs-mbottom-30">
            <button
              className="gdocs-btn-default"
              onClick={this.addTire}
              disabled={this.state.disabledBtn || this.props.disabled}
            >+ {this.props.addBtnText} {this.state.noOfTier < 5 ? this.state.noOfTier + 1 : ''}</button>
          </div>
        </div>
      </div>
    )
  }
}

export default BalanceTiers



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/InterestEnhancementSummary/IETireSetting/BalanceTiers/index.js